import { useEffect, useState } from "react";
import Button from "@/components/base/Button";
import { useHeroSlides } from "@/hooks/usePublicContent";

export default function Hero() {
  const heroSlides = useHeroSlides();
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [heroSlides.length]);

  const slide = heroSlides[active] ?? heroSlides[0];

  return (
    <section className="relative h-[520px] w-full overflow-hidden bg-primary-950 md:h-[640px] lg:h-[720px]">
      {heroSlides.map((item, index) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === active ? "opacity-100" : "opacity-0"
          }`}
          aria-hidden={index !== active}
        >
          <img
            src={item.imagen_url}
            alt=""
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/30 via-primary-950/20 to-primary-950/30"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/30 to-transparent"></div>

      <div className="relative flex h-full w-full items-center pt-16 md:pt-0">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <div className="max-w-2xl">
            <span className="hero-text-outline inline-flex items-center gap-2 rounded-full border border-primary-50/20 bg-primary-950/30 px-3.5 py-1.5 text-xs font-label font-semibold uppercase tracking-[0.18em] text-accent-300 backdrop-blur-sm">
              <i className="ri-truck-line text-sm leading-none" aria-hidden="true"></i>
              Transporte y logística profesional
            </span>

            <h1
              key={slide.id}
              className="hero-text-outline mt-5 text-3xl font-heading font-bold leading-tight text-balance text-primary-50 animate-fade-up md:text-5xl lg:text-[3.4rem]"
            >
              {slide.titulo}
            </h1>

            <p
              key={`${slide.id}-sub`}
              className="hero-text-outline mt-5 max-w-xl text-sm leading-relaxed text-primary-100 animate-fade-up md:text-lg"
              style={{ animationDelay: "80ms" }}
            >
              {slide.subtitulo}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Button to="/solicitar-servicio" variant="primary" size="lg" icon="ri-send-plane-line">
                Solicitar servicio
              </Button>
              <Button
                to="/flota"
                variant="outline"
                size="lg"
                icon="ri-truck-line"
                className="border-primary-50/40 text-primary-50 hover:bg-primary-50/10 hover:border-primary-50/60"
              >
                Ver nuestra flota
              </Button>
            </div>
          </div>

          <div className="mt-10 flex items-center gap-2.5">
            {heroSlides.map((item, index) => (
              <button
                key={item.id}
                type="button"
                onClick={() => setActive(index)}
                aria-label={`Ir a la diapositiva ${index + 1}`}
                aria-current={index === active}
                className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === active ? "w-8 bg-accent-400" : "w-3 bg-primary-50/40 hover:bg-primary-50/70"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}